import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBubble3Background = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 1025 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M501.487 338.753C552.584 262.155 629.935 224.12 680.42 253.268C713.547 272.394 727.407 316.002 721.497 367.051C795.723 352.308 859.526 367.907 874.858 408.854C890.743 451.278 849.521 507.356 779.456 545.109C806.829 586.246 814.184 630.754 794.552 664.758C763.009 719.392 673.147 727.251 589.266 684.592C536.675 761.443 459.419 799.724 409.308 770.792C377.664 752.522 363.819 711.476 368.051 662.559C291.76 670.877 228.721 649.585 217.414 607.388C210.662 582.189 223.614 554.222 250.101 529.19L146.891 425.98H278.355C273.039 387.311 282.083 351.28 306.889 326.474C351.897 281.466 433.862 288.347 501.487 338.753Z",
		fill: "currentColor",
		strokeWidth: 16,
		stroke: "var(--color-light-blue)"
	})
});
const ForwardRef = forwardRef(SvgBubble3Background);
export default ForwardRef;
